import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import styles from "assets/jss/elite-feats-cms/components/cardIconStyle";

const useStyles = makeStyles(styles);

interface CardIconProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "color"> {
  className?: string;
  color?:
    | "warning"
    | "success"
    | "danger"
    | "info"
    | "primary"
    | "rose"
    | "modules"
    | "toolsOne"
    | "toolsTwo"
    | "toolsThree"
    | "toolsFour"
    | "toolsFive";
  children?: React.ReactNode;
}

export default function CardIcon(props: CardIconProps): React.ReactElement {
  const classes = useStyles();
  const { className, children, color, ...rest } = props;
  const cardIconClasses = classNames({
    [classes.cardIcon]: true,
    [classes[(color as string) + "CardHeader"]]: color,
    [className as string]: className !== undefined,
  });
  return (
    <div className={cardIconClasses} {...rest}>
      {children}
    </div>
  );
}
